export default __webpack_public_path__ + "static/media/IAM.5df6c169.svg";